export const CRASH_ZONE_BUFFER = 30;
